import axiosInstance from "@/config/axios";
import type { MutateLaw } from "@/types/law";

const getLaws = async (params?: { [key: string]: string | number }) => {
	const response = await axiosInstance.get("/laws", { params });
	return response.data;
};

const getLaw = async (id: string) => {
	const response = await axiosInstance.get(`/laws/${id}`);
	return response.data;
};

const createLaw = async (data: MutateLaw) => {
	const response = await axiosInstance.post("/laws", data);
	return response.data;
};

const updateLaw = async (id: string | undefined, data: MutateLaw) => {
	const response = await axiosInstance.put(`/laws/${id}`, data);
	return response.data;
};

const deleteLaw = async (id: string) => {
	const response = await axiosInstance.delete(`/laws/${id}`);
	return response.data;
};

export { getLaws, getLaw, createLaw, updateLaw, deleteLaw };
